// extracted by mini-css-extract-plugin
export default {"main":"styles_main__rnZir","errorLine":"styles_errorLine__POR25","transitionItems":"styles_transitionItems__upURY","transitionItem":"styles_transitionItem__mSqPq"};